import styles from 'Pages/TeamDashboard/ProductLibrary/styles.module.scss';

const LoadingState = () => (
  <div className={styles.loadingState}>
    <div className={styles.spinner} />
  </div>
);

export default LoadingState;
